import { render, staticRenderFns } from "./MainDotSeparator.vue?vue&type=template&id=4f1d089e&scoped=true&"
import script from "./MainDotSeparator.vue?vue&type=script&lang=js&"
export * from "./MainDotSeparator.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f1d089e",
  null
  ,true
)

export default component.exports